import React, { useEffect } from 'react';

const DeleteImages = ({ images, onDelete, isSingle = false }) => {
  // Cleanup object URLs to avoid memory leaks
  useEffect(() => {
    return () => {
      if (!isSingle && images) {
        images.forEach((image) => {
          if (image instanceof File || image instanceof Blob) {
            URL.revokeObjectURL(image.previewURL);
          }
        });
      } else if (isSingle && images instanceof File) {
        URL.revokeObjectURL(images.previewURL);
      }
    };
  }, [images, isSingle]);

  const handleDelete = () => {
    onDelete(isSingle ? null : -1); // Delete single or all
  };

  const getImageSource = (image) => {
    if (typeof image === 'string' && image.includes('https')) {
      return image;
    }
    if (image instanceof File || image instanceof Blob) {
      // Check if preview URL is already created
      if (!image.previewURL) {
        image.previewURL = URL.createObjectURL(image);
      }
      return image.previewURL;
    }
    return '';
  };

  return (
    <div className="d-flex mt-2 flex-wrap">
      {images && (isSingle ? (
        <div className="mr-2 img-wrap text-center">
          <img
            src={getImageSource(images)}
            alt="preview"
            className="img-thumbnail"
            style={{ width: 100, height: 100 }}
          />
          <button
            type="button"
            className="action-icon-btn btn btn-danger btn-sm mt-1"
            onClick={handleDelete}
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      ) : (
        images.map((image, index) => (
          <div key={index} className="mr-2 img-wrap text-center">
            <img
              src={getImageSource(image)}
              alt={`preview-${index}`}
              className="img-thumbnail"
              style={{ width: 100, height: 100 }}
            />
            <button
              type="button"
              className="action-icon-btn btn btn-danger btn-sm mt-1"
              onClick={() => onDelete(index)}
            >
              <i className="fas fa-trash-alt"></i>
            </button>
          </div>
        ))
      ))}
    </div>
  );
};

export default DeleteImages;
